/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { compose } from 'redux';
import {
    object,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { KeyboardBackspace } from '@material-ui/icons';

const styles = (theme) => {
    const { palette } = theme;
    return {
        headerPartWrapper: {
            '&.HeaderPartContainer': {
                borderBottom: `2px solid ${palette.common.black}`,
                marginBottom: '2em',
                '& a': {
                    color: palette.common.black,
                    textDecoration: 'none',
                    fontWeight: 700,
                    letterSpacing: '0.5px',
                    '& svg': {
                        verticalAlign: 'bottom',
                    },
                    '& span': {
                        paddingLeft: '5px',
                    },
                    '&:hover': {
                        textDecoration: 'none',
                    },
                    '& .productName': {
                        fontWeight: 'normal',
                    },
                },
                '& .pt-4': {
                    paddingTop: '1.5rem !important',
                },
            },
        },
    };
};

const HeaderPart = (props) => {
    const { classes } = props;
    return (
        <div className={`${classes.headerPartWrapper} HeaderPartContainer`}>
            <div className="pt-4">
                <a href="/plant-guide" aria-label="Back to Index">
                    <KeyboardBackspace />
                    <span className="productName">Back to Index</span>
                </a>
            </div>
        </div>
    );
};

HeaderPart.propTypes = {
    classes: object.isRequired,
};

export default compose(withStyles(styles))(HeaderPart);
